import logger from '../../utils/logger';
import { lendingApiFetchWithoutContentType } from '../lendingApi/lendingApiQueries';

type TCompanyQuestionHistory = {
  question: string;
  answer: string;
};

export type TSicCode = string[];

type TCompanyQuestionContext = {
  sic_code?: TSicCode;
  incorporation_date?: string;
};

export type TCompanyQuestionRequest = {
  context: TCompanyQuestionContext;
  history?: TCompanyQuestionHistory[];
};

export type TCompanyQuestionResponse = {
  inference_question?: string;
  questions_complete: boolean;
};

export const postCompanyQuestion = async ({
  applicationId,
  data,
}: {
  applicationId: string;
  data: TCompanyQuestionRequest;
}): Promise<TCompanyQuestionResponse> => {
  const response = await lendingApiFetchWithoutContentType(
    `/api/ai-company-question/question-and-answer/${applicationId}`,
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
    {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  );

  if (!response.ok) {
    logger.error('Failed to generate first ai question');
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};
